import {
  MotionGrid as Grid,
  MotionFlex as Flex,
  appearBelow,
} from "utils/motion";
import Trans from "components/base/Trans";
import Text from "components/base/Text";
import Link from "components/base/Link";
import SocialLink from "components/base/SocialLink";
import Facebook from "components/icons/social/Facebook";
import Instagram from "components/icons/social/Instagram";
import LinkedIn from "components/icons/social/LinkedIn";
import Youtube from "components/icons/social/Youtube";
import Twitter from "components/icons/social/Twitter";
import TikTok from "components/icons/social/TikTok";

const year = new Date().getFullYear();

const FooterNote = () => (
  <Flex
    variants={appearBelow}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.4 }}
    justifyContent="space-between"
    alignItems="center"
    direction={["column", "column", "row"]}
    wrap
    pt={5}
    pb={12}
  >
    <Grid templateColumns="repeat(2, auto)" gap={6} alignItems="center">
      <Link
        href="/privacy-policy"
        color="white"
        letterSpacing="widest"
        textAlign="center"
        opacity={0.6}
        target="_blank"
        _hover={{ textDecoration: "none", opacity: 1 }}
        fontSize="xs"
      >
        <Trans id="LBL_FOOTER_PRIVACY_LINK_NAME" />
      </Link>
      <Text color="white" opacity={0.8} type="p_xs" textAlign="center">
        <Trans id="LBL_FOOTER_COPYRIGHT" values={{ year }} />
      </Text>
    </Grid>
    <Grid templateColumns="repeat(6, auto)" gap={3} py={["md", "md", 0]}>
      <SocialLink
        ariaLabel="facebook"
        href="https://www.facebook.com/hillhelicopters"
      >
        <Facebook width="32px" height="32px" color="white" />
      </SocialLink>
      <SocialLink
        ariaLabel="instagram"
        href="https://www.instagram.com/hillheli"
      >
        <Instagram width="32px" height="32px" color="white" />
      </SocialLink>
      <SocialLink
        ariaLabel="linkedin"
        href="https://www.linkedin.com/company/hillhelicopters/"
      >
        <LinkedIn width="32px" height="32px" color="white" />
      </SocialLink>
      <SocialLink
        ariaLabel="youtube"
        href="https://www.youtube.com/c/HillHelicopters"
      >
        <Youtube width="32px" height="32px" color="white" />
      </SocialLink>
      <SocialLink ariaLabel="twitter" href="https://x.com/HillHelicopters">
        <Twitter width="32px" height="32px" />
      </SocialLink>
      <SocialLink
        ariaLabel="tiktok"
        href="https://www.tiktok.com/@hillhelicopters"
      >
        <TikTok width="32px" height="32px" color="white" />
      </SocialLink>
    </Grid>
  </Flex>
);

export default FooterNote;
